<template>
    <div>
        <div class="fixed bg-gray-500 opacity-50 min-h-screen min-w-screen h-full w-full top-0 left-0 right-0 z-40"></div>
        <div @click="close" class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-50">
            <div @click.stop class="p-8 w-[30rem] text-center bg-white rounded-lg">
                <p class="mb-4 text-base">{{ title }}</p>
                <p v-if="description" class="mb-6 text-sm">{{ description }}</p>
                <div class="flex items-center justify-center">
                    <button @click="close" type="button" class="w-full text-center bg-custom-blue hover:bg-custom-blue-hover flex items-center justify-center text-white font-medium rounded-lg text-sm px-5 py-2">Хорошо</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ComfirmationModalWindow",
        props: {
            isOpened: {
                type: Boolean,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: false,
            }
        },
        data() {
            return {

            }
        },
        methods: {
            close() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:isOpened", false);
            }
        }
    }
</script>